const CANONICAL_ORG_KEY = 'safapply_admin_canonical_org_id';
const PORTAL_ALIAS_KEY = 'safapply_admin_portal_alias';
const AUTH_ORG_KEY = 'safapply_admin_auth_org_id';

export function setAuthOrganisationId(canonicalOrgId) {
  if (canonicalOrgId) {
    sessionStorage.setItem(AUTH_ORG_KEY, canonicalOrgId);
  }
}

export function getAuthOrganisationId() {
  return sessionStorage.getItem(AUTH_ORG_KEY) || '';
}

export function clearAuthOrganisationId() {
  sessionStorage.removeItem(AUTH_ORG_KEY);
}

export function setOrgRoutingKeys(canonicalOrgId, portalAlias) {
  if (canonicalOrgId) {
    sessionStorage.setItem(CANONICAL_ORG_KEY, canonicalOrgId);
  }
  if (portalAlias) {
    sessionStorage.setItem(PORTAL_ALIAS_KEY, portalAlias);
  }
}

export function getCanonicalOrgId(fallbackRouteSlug) {
  return (
    sessionStorage.getItem(CANONICAL_ORG_KEY) ||
    fallbackRouteSlug ||
    ''
  );
}

export function getPortalSlug(fallbackRouteSlug) {
  return (
    sessionStorage.getItem(PORTAL_ALIAS_KEY) ||
    sessionStorage.getItem(CANONICAL_ORG_KEY) ||
    fallbackRouteSlug ||
    ''
  );
}

export function migrateAdminStorage(fromSlug, toSlug) {
  if (!fromSlug || !toSlug || fromSlug === toSlug) {
    return;
  }
  ['access_token', 'refresh_token', 'user'].forEach((item) => {
    const fromKey = `safapply_admin_app_${fromSlug}_${item}`;
    const value = localStorage.getItem(fromKey);
    if (value != null) {
      localStorage.setItem(`safapply_admin_app_${toSlug}_${item}`, value);
      localStorage.removeItem(fromKey);
    }
  });
}

export function replaceOrgSlugInPath(pathname, fromSlug, toSlug) {
  if (!pathname || !fromSlug || !toSlug || fromSlug === toSlug) {
    return pathname;
  }
  const prefix = `/${fromSlug}`;
  if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
    return pathname.replace(prefix, `/${toSlug}`);
  }
  return pathname;
}

/** Slugs that may hold admin auth tokens (write slug, route, alias, canonical id). */
export function getAdminStorageSlugCandidates(routeSlug) {
  const route = routeSlug || '';
  const writeSlug = getAdminStorageWriteSlug(route);
  const alias = sessionStorage.getItem(PORTAL_ALIAS_KEY) || '';
  const canonical = sessionStorage.getItem(CANONICAL_ORG_KEY) || '';
  const seen = new Set();
  const ordered = [];
  [writeSlug, route, alias, canonical].forEach((slug) => {
    if (slug === undefined || slug === null || seen.has(slug)) {
      return;
    }
    seen.add(slug);
    ordered.push(slug);
  });
  return ordered;
}

/** Preferred slug for new token writes (alias when known, else route). */
export function getAdminStorageWriteSlug(routeSlug) {
  return getPortalSlug(routeSlug);
}

export function isAuthOrganisationMismatch(urlCanonicalOrgId) {
  const authOrgId = getAuthOrganisationId();
  if (!authOrgId || !urlCanonicalOrgId) {
    return false;
  }
  return authOrgId !== urlCanonicalOrgId;
}

/**
 * Only rewrite the URL segment to portal_alias for the org currently being resolved.
 * Prevents stale Redux portalSlug from pulling a new org route back to the previous org's alias.
 */
export function shouldRewriteRouteToPortalAlias({
  routeOrgName,
  portalAlias,
  resolvedCanonicalOrgId,
  hasAccessToken,
}) {
  if (!routeOrgName || !portalAlias || routeOrgName === portalAlias) {
    return false;
  }
  if (!resolvedCanonicalOrgId) {
    return false;
  }
  if (hasAccessToken && isAuthOrganisationMismatch(resolvedCanonicalOrgId)) {
    return false;
  }
  return true;
}
